import Script from 'next/script';

export default function GeoIP(): JSX.Element {
  return (
    <Script
      src="//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js"
      type="text/javascript"
      key="maxmind"
      defer
    />
  );
}
